import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { getDefaultHomePath } from '@/constants/modules';

/**
 * Redireciona para a tela inicial do usuário: Dashboard se tiver permissão,
 * senão o primeiro módulo cadastrado em allowedModules.
 */
export function HomeRedirect() {
  const { user } = useAuthStore();
  const to = getDefaultHomePath(user ?? null);
  return <Navigate to={to} replace />;
}
